import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';

import { useTranslation } from 'react-i18next';

// style
import tableIcons from '../../../../components/table/MaterialTableIcon';

// Utils
import exportCsv from '../../../../utils/export/Csv';
export default function FlashfloodDetailList(props) {
  const { t } = useTranslation();
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('จังหวัด'),
            title_export: t('จังหวัด'),
            field: 'province_name',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.province_name}`,
          },
          {
            title: t('อำเภอ'),
            title_export: t('อำเภอ'),
            field: 'amphoe_name',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.amphoe_name}`,
          },
          {
            title: t('ตำบล'),
            title_export: t('ตำบล'),
            field: 'tambon_name',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.tambon_name}`,
          },
          {
            title: 'FFPI',
            title_export: 'FFPI',
            field: 'ffpi',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.ffpi}`,
          },
          {
            title: t('ฝนสะสม 1 วันล่วงหน้า'),
            title_export: t('ฝนสะสม 1 วันล่วงหน้า'),
            field: 'rainforcast_1d',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.rainforcast_1d}`,
          },
          {
            title: t('สถานีโทรมาตรเพื่อติดตามสถานการณ์'),
            title_export: t('สถานีโทรมาตรเพื่อติดตามสถานการณ์'),
            field: 'station_name',
            type: 'string',
            width: 200,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.station_name}`,
          },
          {
            title: t('ลุ่มน้ำ'),
            title_export: t('ลุ่มน้ำ'),
            field: 'basin_name',
            type: 'string',
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.basin_name}`,
          },
        ]}
        data={datas}
        localization={{
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: isExport,
          showTitle: false,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

FlashfloodDetailList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
